var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.forcedFollowUp && !_vm.makeAppointmentSuccess
        ? [
            _vm.followUpOptions && _vm.followUpOptions.length > 1
              ? _c(
                  "FormGroup",
                  {
                    staticClass: "mt-2",
                    attrs: {
                      label: "Jetzt bist du wieder dran. Was willst du tun?",
                      "label-classes": ["font-weight-bold"]
                    }
                  },
                  [
                    _c("RadioGroup", {
                      staticClass: "mt-3",
                      attrs: { options: _vm.followUpOptions, stacked: "" },
                      model: {
                        value: _vm.followUp,
                        callback: function($$v) {
                          _vm.followUp = $$v
                        },
                        expression: "followUp"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.computedFollowUp
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _vm.computedFollowUp === _vm.followUps.makeAppointment
                ? [
                    _c("MakeAppointment", {
                      attrs: {
                        message: _vm.message,
                        "applicant-name": _vm.applicantName,
                        action: _vm.actionMakeAppointment,
                        "with-cancel-button": ""
                      },
                      on: {
                        success: function($event) {
                          return _vm.$emit("processed")
                        },
                        cancel: function($event) {
                          return _vm.$emit("cancel")
                        }
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.computedFollowUp === _vm.followUps.requestVita
                ? [
                    _c("RequestVita", {
                      attrs: { loading: _vm.sendingRequest },
                      on: {
                        cancel: function($event) {
                          _vm.followUp = undefined
                        },
                        request: _vm.requestVita
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }